<template>
  <div
    class="modal-ai-chat"
    :class="{
      mobile: $device.isMobile,
      'is-full-screen': isFullScreen || $device.isMobile,
      'is-show': isAiChatShow,
    }"
  >
    <BaseHeader
      v-if="$device.isMobile"
      mode="light"
      :title="title"
      :left-arrow="true"
      :back-on-click-left="false"
      :is-title-bold="true"
      @on-click-left="close"
    />
    <div v-else class="desktop-header">
      <i
        :class="
          isFullScreen
            ? 'icon-arrows-diagonal-minimize'
            : 'icon-arrows-diagonal-maximize'
        "
        @click="isFullScreen = !isFullScreen"
      ></i>
      <h3>{{ title }}</h3>
      <i class="icon-X" @click="close"></i>
    </div>
    <div ref="chats" class="chats">
      <div
        v-for="(chat, index) in chatList"
        :key="index"
        class="chat-item"
        :class="{'is-ai': chat.isAi}"
      >
        <div class="chat-content">
          <div class="avatar">
            <img v-if="chat.isAi" :src="aiAvatarUrl" />
            <img v-else :src="userAvatarUrl" />
          </div>
          <div class="message">
            <h4 v-if="chat.message">{{ chat.message }}</h4>
            <div v-else class="typing_loader"></div>
          </div>
        </div>
        <div v-show="chat.isAi" class="like-or-dislike">
          <i
            class="icon-like"
            :class="{'is-active': chat.record?.isLike}"
            @click="likeAi(chat)"
          ></i>
          <i
            class="icon-dislike"
            :class="{'is-active': chat.record && !chat.record.isLike}"
            @click="dislikeAi(chat)"
          ></i>
        </div>
      </div>
    </div>
    <b-form class="input-div" @submit.prevent="sendChat()">
      <b-form-input
        v-model="chatInput"
        type="text"
        :placeholder="$t('請輸入問題')"
        @compositionstart="isComposing = true"
        @compositionend="isComposing = false"
      />
      <i
        class="text-28 icon-send"
        :class="{'is-active': chatInput}"
        @click="sendChat()"
      ></i>
    </b-form>
  </div>
</template>

<script>
import AI_CHAT from '@/constant/aiChat.js';
import BaseHeader from '@/components/Base/BaseHeader';
import {mapGetters} from 'vuex';
import getAvatarUrl from '@/lib/base/avatarUrl.js';

export default {
  components: {
    BaseHeader,
  },
  data() {
    return {
      isFullScreen: false,
      isComposing: false,
      chatInput: '',
      chatMode: '',
    };
  },
  computed: {
    ...mapGetters('aiChat', ['isAiChatShow', 'aiChatMode', 'chatList']),
    title() {
      switch (this.chatMode) {
        case AI_CHAT.MODES.TEACHER:
          return this.$t('教學助手');
        default:
          return this.$t('小幫手');
      }
    },
    userData() {
      return this.$store.getters['user/userData'];
    },
    userAvatarUrl() {
      return getAvatarUrl(this.userData.avatar);
    },
    aiAvatarUrl() {
      switch (this.chatMode) {
        case AI_CHAT.MODES.TEACHER:
          return require('@/assets/img/chatbot/TEACHER.svg');
        default:
          return require('@/assets/img/chatbot/NORMAL.svg');
      }
    },
  },
  watch: {
    chatList() {
      this.$nextTick(() => {
        const chats = this.$refs.chats;
        if (chats) {
          chats.scrollTop = chats.scrollHeight;
        }
      });
    },
    aiChatMode(newMode) {
      if (newMode) this.chatMode = newMode;
    },
  },
  // async created() {},
  // mounted() {},
  methods: {
    close() {
      this.$store.dispatch('aiChat/closeAiChat');
    },
    async sendChat() {
      const message = this.chatInput;
      if (this.isComposing) return;
      if (!message) return;
      this.chatInput = '';
      this.$store.dispatch('aiChat/sendChat', {message});
    },
    async likeAi(chat) {
      this.$store.dispatch('aiChat/rateAiResponse', {chat, isLike: true});
    },
    async dislikeAi(chat) {
      this.$store.dispatch('aiChat/rateAiResponse', {chat, isLike: false});
    },
  },
};
</script>

<style lang="scss">
.modal-ai-chat {
  position: absolute;
  width: 400px;
  right: 4px;
  bottom: 4px;
  height: 0;
  z-index: 9999;
  opacity: 0;
  background: $white;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease-in-out;
  &.is-full-screen {
    width: 100%;
    right: 0;
    bottom: 0;
    transition: opacity 0.3s ease-in-out;
  }
  &.is-show {
    display: flex;
    height: 70%;
    border: 4px solid var(--Color-PapayaWhip, #fff1de);
    opacity: 1;
    &.is-full-screen {
      height: 100%;
      border: 0px;
      opacity: 1;
    }
  }

  .desktop-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    background: #f6ede0;
    h3 {
      color: var(--Text-Subhd, #606266);
    }
    i {
      cursor: pointer;
      width: 38px;
      height: 38px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      color: $primary;
      background: $white;
      box-shadow: rgba(199, 199, 199, 0.25) 0px 4px 20px 0px;
    }
  }
  .chats {
    flex: 1;
    overflow-y: auto;
    background: $white;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }
  .input-div {
    display: flex;
    align-items: center;
    padding: 8px;
    display: flex;
    border-top: 1px solid $line-2;
    .icon-send {
      margin-left: 8px;
      cursor: pointer;
      color: $font-grayscale-3;
      &.is-active {
        color: $primary;
      }
    }
  }
}

.chat-item {
  display: flex;
  padding: 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  .chat-content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    flex-direction: row-reverse;
    .message {
      display: flex;
      max-width: 250px;
      padding: 12px 16px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 16px 0px 16px 16px;
      border: 1.5px solid rgba(0, 0, 0, 0);
      background: var(--Color-Orange, #ffbd5a);
      word-break: break-word;
    }
    .avatar {
      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
    }
  }
  .like-or-dislike {
    display: flex;
    padding-left: 48px;
    align-items: center;
    gap: var(--spacing-s, 16px);
    align-self: stretch;
    color: $font-grayscale-2;
    i {
      cursor: pointer;
      &.is-active,
      &:hover {
        color: $primary;
      }
    }
  }

  &.is-ai {
    .chat-content {
      flex-direction: row;
      .message {
        border-radius: 0px 16px 16px 16px;
        background: var(--Color-PapayaWhip, #fff1de);
        color: var(--Text-Primary, #303133);
      }
    }
  }
}

/*Typing Loader*/
.typing_loader {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  animation: typing 1s linear infinite alternate;
  position: relative;
  left: -22px;
  padding: 8px;
  margin: 6px 22px;
}

@keyframes typing {
  0% {
    background-color: rgba(144, 147, 153, 1);
    box-shadow: 22px 0px 0px 0px rgba(144, 147, 153, 0.2),
      44px 0px 0px 0px rgba(144, 147, 153, 0.2);
  }
  25% {
    background-color: rgba(144, 147, 153, 0.4);
    box-shadow: 22px 0px 0px 0px rgba(144, 147, 153, 2),
      44px 0px 0px 0px rgba(144, 147, 153, 0.2);
  }
  75% {
    background-color: rgba(144, 147, 153, 0.4);
    box-shadow: 22px 0px 0px 0px rgba(144, 147, 153, 0.2),
      44px 0px 0px 0px rgba(144, 147, 153, 1);
  }
}
</style>
